import { ReactNode } from 'react';
import { StyledTableHeadCell } from './styled';

export type TableHeadCellProps = {
	children: ReactNode | ReactNode[];
};

export const TableHeadCell = ({ children }: TableHeadCellProps) => <StyledTableHeadCell>{children}</StyledTableHeadCell>;
